module.exports = __webpack_public_path__ + "img/chart_edit.2c956927.svg";